import { createContext } from 'react';

const categoryContext = createContext({
  setCategoryId: () => {},
  categoryId: '',
  setEventType: () => {},
  eventType: '',
  shouldShowLoyalty: true,
});
export default categoryContext;
